import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { NgxImageGalleryModule } from 'ngx-image-gallery';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { SponsorListComponent } from 'src/app/components/sponsor-list.component';
import { MilestoneListComponent } from 'src/app/club/timeline/milestone-list.component';
import { MilestoneComponent } from 'src/app/club/timeline/milestone.component';
import { AppRoutingModule } from './/app-routing.module';
import { SlideshowComponent } from 'src/app/components/slideshow.component';
import { SlideshowImageComponent } from 'src/app/components/slideshow-image.component';
import { NavigationComponent } from 'src/app/components/navigation-main.component';
import { MemberDetailViewComponent } from 'src/app/members/member-detail-view.component';
import { MemberOverviewComponent } from 'src/app/members/member-overview.component';
import { TeamComponent } from 'src/app/members/team-component';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { CopyrightComponent } from 'src/app/components/copyright.component';
import { ContactComponent } from 'src/app/components/contact.component';
import { CommitteeComponent } from 'src/app/club/committee/committee.component';
import { MapComponent } from 'src/app/club/map/map.component';
import { TrainingComponent } from 'src/app/club/training/training.component';
import { BecomeMemberComponent } from 'src/app/club/become-member/become-member.component';
import { SuccessesComponent } from 'src/app/club/successes/successes.component';
import { AdultPlayersComponent } from 'src/app/members/adult-players.component';
import { MemberOverviewListComponent } from 'src/app/members/member-overview-list.component';
import { JuniorPlayersComponent } from 'src/app/members/junior-players.component';
import { CoachesComponent } from 'src/app/members/coaches.component';
import { EventReportComponent } from 'src/app/calendar/event-report.component';
import { DashboardComponent } from 'src/app/components/dashboard.component';
import { CalendarComponent } from 'src/app/calendar/calendar.component';
import { CalendarDayComponent } from 'src/app/calendar/calendar-day.component';
import { HoverClassDirective } from 'src/app/directives/hover.directive';
import { GalleryOverviewListComponent } from 'src/app/gallery/gallery-overview-list.component';
import { GalleryComponent } from 'src/app/gallery/gallery.component';
import { MembersComponent } from 'src/app/members/members.component';
import { ClubComponent } from 'src/app/club/club.component';
import { DeviceDetectorService } from "ngx-device-detector";
import { BreadcrumbsComponent } from 'src/app/components/breadcrumbs/breadcrumbs.component';
import { MobileNavigationComponent } from './components/mobile-navigation/mobile-navigation.component';
import { GoBackComponent } from 'src/app/components/go-back/go-back.component';

import { registerLocaleData } from '@angular/common';
import localeDeAt from "@angular/common/locales/de-AT";
import { BannerComponent } from './components/banner.component';

registerLocaleData(localeDeAt);

@NgModule({
  declarations: [
    AppComponent,
    SponsorListComponent,
    MilestoneListComponent,
    MilestoneComponent,
    SlideshowComponent,
    SlideshowImageComponent,
    NavigationComponent,
    MemberDetailViewComponent,
    MemberOverviewComponent,
    TeamComponent,
    SafePipe,
    CopyrightComponent,
    ContactComponent,
    CommitteeComponent,
    MapComponent,
    TrainingComponent,
    BecomeMemberComponent,
    SuccessesComponent,
    MemberOverviewListComponent,
    AdultPlayersComponent,
    JuniorPlayersComponent,
    CoachesComponent,
    EventReportComponent,
    DashboardComponent,
    CalendarComponent,
    CalendarDayComponent,
    HoverClassDirective,
    GalleryOverviewListComponent,
    GalleryComponent,
    MembersComponent,
    ClubComponent,
    BreadcrumbsComponent,
    MobileNavigationComponent,
    GoBackComponent,
    BannerComponent
  ],
  imports: [
    NgxImageGalleryModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "de-at" },
    DeviceDetectorService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
